import React, { Component, useState, useEffect } from 'react';
import {injectCartContainer} from '../react/CartContainer'

import {round} from 'lodash'
import './CheckoutTips.scss'
import './CheckoutTipsDark.scss'

const PERCENTAGES = [
  10, 15, 20
]



function CheckoutTips ({ preTipTotalWithTax, cartType, cart, shopId }) {
  const usePercentageTipping = (preTipTotalWithTax > 10)
  const tipOptions = usePercentageTipping ?
    PERCENTAGES.map((number) => {
      return({
        display: `${number}%`,
        tipAmount: Math.round(preTipTotalWithTax * number)
      })
    }) :
    [1,2,3,4].map((dollar) => ({ display: `$${dollar}`, tipAmount: dollar * 100 }))
  // preselect 15% ($1 on small orders) and keep it in step with the total until the customer picks
  const defaultTipAmount = usePercentageTipping ? tipOptions[1].tipAmount : tipOptions[0].tipAmount
  useEffect(() => {
    if (!cart.state.preTipUserPicked && (cart.state.preTipPrimaryCents !== defaultTipAmount)) {
      cart.setState({preTipPrimaryCents: defaultTipAmount})
    }
  }, [cart, defaultTipAmount, cart.state.preTipUserPicked, cart.state.preTipPrimaryCents])
  function handleSelectTip (tipAmount) {
    console.log('selected: ', tipAmount)
    cart.setState({preTipPrimaryCents: tipAmount, preTipUserPicked: true})
  }
  function handlePickCustomTip () {
    console.log('custom tip')
    const inputString = window.prompt("Enter Tip:", '') || ''
    const digitsOnlyString = inputString.replace(/[^0-9\.]/g, '')
    const tipDollars = parseFloat(digitsOnlyString)
    if (tipDollars || (tipDollars === 0)) {
      cart.setState({preTipPrimaryCents: tipDollars * 100, preTipUserPicked: true})
    } else {
      console.log('no digits entered')
    }
  }
  const selectTipAmountInCents = cart.state.preTipPrimaryCents
  // determine if need to display custom-entered tip (or a tip that someone doesn't exist)
  let isCustomTip = false
  if (parseInt(selectTipAmountInCents)) {
    isCustomTip = true
  }
  tipOptions.forEach(({tipAmount}) => {
    if (tipAmount === selectTipAmountInCents) {
      isCustomTip = false
    }
  })

  let tipText = (cartType === 'DELIVERY') ?
  "100% goes to driver, thank you!" :
  "100% goes to staff, thank you!"

  if ((shopId === 'cravesushi')&&(cartType === 'PICKUP')) {
    tipText = ''
  }

  return(
    <section className="checkout-tips-section">
      <fieldset>
        <legend className="instruction">Add a tip:</legend>
        <p className="hint">{tipText}</p>
        <div className="all-tip-options">
          <div className="options-container primary">
            {tipOptions.map(({display, tipAmount}, index) => {
              const id = tipAmount
              // console.log(tipAmount, selectTipAmountInCents)
              const selectedOptionClass = (selectTipAmountInCents === (tipAmount)) ?
                " selected" : ""
              return(
                <div
                  key={id}
                  className={"tip-option-clickable" + selectedOptionClass}>
                  <input
                    aria-label={`tip ${tipAmount / 100} dollars`}
                    onChange={handleSelectTip.bind(this, tipAmount)}                    
                    name="primary-tip" type="radio" id={id} value={tipAmount} />
                  <label 
                    
                    htmlFor={id}>
                    <span className="content">{display}</span>
                    {usePercentageTipping && <span className="actualAmount">
                      ${tipAmount / 100}
                    </span>}
                  </label>
                </div>
              )
            })}
          </div>



          <div className="options-container custom">
            <div className={"tip-option-clickable custom" + (isCustomTip ? (' selected') : "")}>
              <input
              id=""
              aria-label={`custom tip`}
                onClick={handlePickCustomTip}
                name="primary-tip" type="radio" id="custom" value={"CUSTOM"} />
              <label htmlFor="custom">
                {!isCustomTip ?
                  <span 
                  
                  className="content">custom</span> :
                  <span 
                 
                  className="content">
                    ${selectTipAmountInCents / 100}
                    <span className="edit-label">edit</span>
                  </span>
                }
              </label>
            </div>
          </div>



        </div>
      </fieldset>
    </section>
  )
}

export default injectCartContainer(CheckoutTips)
